import { AxiosError, RawAxiosRequestConfig } from 'axios';
import { idsApiClient } from 'api/axiosApiClient';
import qs from 'qs';

// add a second `options` argument here if you want to pass extra options to each generated query
// prettier-ignore
export const customMutator = <T,>(config: RawAxiosRequestConfig, options?: RawAxiosRequestConfig): Promise<T> => {
    config.paramsSerializer = {
        serialize: function (params) {
        return qs.stringify(params, {arrayFormat: 'repeat'})
    }};

    const promise = idsApiClient({
        ...config,
        ...options,
    }).then(({ data }) => data);

    return promise;
};

export type ErrorType<Error> = AxiosError<Error>;
